export enum FileUploadProgressStatus {
    STARTED = 'started',
    UPLOADING = 'uploading',
    COMPLETED = 'completed',
    CALLING_CALLBACK = 'callingCallback',
    COMPLETED_CALLBACK = 'completedCallback',
    FAILED = 'failed',
}

export interface FileUploadProgress {
    filename: string;
    url: string | undefined;
    status: FileUploadProgressStatus;
    percent: number | undefined;
    error: any;
}
